<!--
@name 硕士教育-会计与管理硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          会计与管理专业旨在为企业培养高层次、应用型会计管理人才，为不断变化的国
          际形势及企业发展奠定坚实的后盾。
        </div>
        <div class="selector-indent">该专业课程涵盖了企业战略管理、全面预算管理与应用、高级财务报表分析、国
          际税收制度等领域的知识和技能。学生将学习财务报表分析、成本控制、预算管理、
          投资决策等会计和财务管理的核心概，念和方法。同时，我们也注重培养学生的领导才
          能和团队合作能力，通过案例分析、团队项目和实习等实践活动，帮助学生将理论知
          识应用于实际情境中。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">卓越资质</p>
          <p>AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。</p>
          <p class="advantage-title">正规保障</p>
          <p>免考试，面试审核制入学，校本部直招，法国校本部学籍注册，中国国内在职研读。</p>
          <p class="advantage-title">课程严谨</p>
          <p>
            遵循国际商学院协会(AACSB)
            标准设置课程，引入国际先进管理理念教材，依
            托经典案例分析，深化知识体系。。</p>
          <p class="advantage-title">实战体系</p>
          <p>
            立足本土实用导向的课程设计，“课堂讲授+案例分析+共创工作坊+沉浸式研学”多种形式相结合，提升理论应用、分析和解决实际管理问题的能力。</p>
          <p class="advantage-title">中外联合</p>
          <p>国内一流大学师资及业内专家强强联合，法国高校教授鼎力加持。</p>
          <p class="advantage-title">资源对接</p>
          <p>庞大的校友网络、专家智库、政府与金融机构链接等，搭建高端商务交流、资源整合的优质平台。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <div>
          法国布雷斯特高等商学院会计与管理硕士专业采用线上和线下教学、自主
          学习和毕业论文相结合的方式进行为期一年半的学习。
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程设计</div>
        <p>会计与管理专业硕士学制18个月，必修课程共16门，修满60学分进入论文答辩阶段。</p>
        <img src="@/assets/images/personRain/mam-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">师资力量</div>
        <p>何杨：中央财经大学财税学院副院长。本硕博就读于中国人民大学财政金融学院，2010年获得经济学博
          士，中国社会科学院财经战略研究院博士后，美国印第安纳大学公共事务与环境学院访问学者。
          中国国际税收研究会学术研究委员、北大一林肯土地政策与城市发展研究中心兼职研究员，入选
          首批全国税务领军人才培养对象、北京市青年英才和北京市国家治理青年人才。</p>
        <p>张美中：
          中央财经大学税务管理系副主任，中央财经大学税务教育研究所研究员，博士，北京大学、清华
          大学特聘教授，CCTV”中国创业楷模”栏目点评专家。主持或参与中国国际税收研究会，北京市
          地方税务局与中央财经大学科题共6项，出版《税收契约理论研究》等财务与税收专业书籍共20
          余部，财经类核心杂刊发表论文60余篇，先后获得中央财经大学两届涌金基金学术奖。近五年先
          后为国务院机关事务管理局、海南航空集团公司、中国国电投、国华电力公司等大型集团公司和
          上干家民营企业提供税务内训和纳税筹划咨询。</p>
        <p>肖土盛：
          中央财经大学会计学院管理会计系系主任，博士，硕士生导师，国家自然科学基金通讯评审专家；
          鸿基世业奖励基金一国际一流学术成果奖，2019。《JOURNAL OF CORPORATE FINANCE
          》、《CHINA JOURNAL OF ACCOUNTING STUDIES》、《CHINA FINANCE REVIEW
          INTERNATIONAL》、《管理世界》、《经济学（季刊）》、《南开管理评论》、《中国工业经济》
          、《财经研究》等期刊匿名审稿人。研究领域：公司价值、信息披露、审计等资本市场相关的会计
          与财务问题。</p>
        <p>张明昂：
          任职于中央财经大学财税学院，清华大学经济学博士，美国康奈尔大学访问学者，美国康奈尔大学
          公派联合培养博士生，两次获得清华大学硕士、博士生国家奖学金，《世界经济》匿名审稿人。主
          要研究领域为公共财政、劳动经济学、发展经济学、应用微观计量经济学，论文发表（接收）在
          《ECONOMICS OF TRANSITION》、《经济学（季刊）》、《经济学报》、《经济学家》等
          期刊。</p>
        <p>马军生：
          复旦大学会计学博士、上海证券交易所博士后，北京大学、清华大学、复旦大学、上海交大等多
          所高校特聘讲师。CCTV证券资讯频道特约嘉宾，国内财务、资本与风控领域资深专家，致力于
          财税、风险管理、资本运营领域研究及实务。曾任职大型央企、中国银行，担任多家企业财务顾
          问，指导几十家上市公司和企事业单位建立内控体系并辅导实施。擅长财务报表分析、内部控
          制、风险管理及财务管控。出版多部专著，编著发表论文六十多篇，主持国家科技部创新基金、
          博士后基金、会计学会等多项课题。</p>
        <p>孙继伟：
          复旦大学管理学院博士，中国首位问题管理专家，上海大学教授、大简资本创始人。曾担任李嘉
          诚旗下合资企业总裁助理，海尔、微软等多家单位的创新创业导师。出版《企业管理视野中的风
          险投资》等专著6部，主持完成多项PEVC投资项目，多次应新华社等媒体和报刊邀请担任评论
          嘉宾。从事创业投资和股权投资的研究和实战操作20年，凭借原创的工具、多年的实战、亲身经
          历的案例，帮学员拨开迷雾、理清思路、实际运用。</p>
        <p>郑庆华：
          北京化工大学会计系原主任、研究生导师、全国高级会计师考试资深主讲专家，北京市高级会计
          师评委、教育部应用型创新大赛评委；上海国家会计学院外聘教授、公司独立董事、审计委员会
          主任，曾任国务院国资委外部专家；在国务院国资委、中组部、中金公司、中信证券、国泰君
          安、国家电网总部、中海油、中海油服、SOHO中国、三一重工、光明集团、中国化工集团、北
          京地税等100多家单位授课，享有很好的口碑。</p>
        <p>范晓东：
          中欧商学院、上海国家会计学院特聘师资，两家世界五百强企业高管，著名成本管控实战专家，
          受邀讲座近百场，培训学员万余名。在国内率先提出目标经济学，畅销书《500强企业成本核算
          实务》作者。</p>
        <p>王春：
          我国知名财税专家，税务专业跨世纪学科带头人，中国注册税务师、中国注册资产评估师。从事
          财税相关工作20余年，对中国财税相关行业发展历史有深刻的理解，在财税发展方向方面有着超
          强的洞察力和预见力。担任多家大型集团及上市公司财税顾问。在企业涉税领域积累了丰富的行
          业经验，自行开发的课程帮助企业解决了许多涉税疑点、难点，风趣幽默的讲课风格使得课程得
          到了学员们的一致好评。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有3年及以上工作经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">会计与管理硕士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'MasterAccount',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9E/wKgCEmfFxJmAKl-hAd1OnuAO_OY837.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/masterAccount.vue